import contractorAuthApi from '../../../api/ContractorAuthApi';

export default {
  name: 'ContractorSignIn',
  data() {
    return {
      email: '',
      password: '',
      showPassword: false,
      isLoading: false,
      errorMessage: '',
      successMessage: '',
      emailError: '',
      passwordError: ''
    };
  },
  
  computed: {
    isFormValid() {
      return this.email.trim() !== '' && 
             this.password.trim() !== '' && 
             this.isValidEmail(this.email) &&
             !this.emailError && 
             !this.passwordError;
    }
  },

  watch: {
    email() {
      this.validateEmail();
      this.clearMessages();
    },
    password() {
      this.validatePassword();
      this.clearMessages();
    }
  },

  mounted() {
    // 既にログイン済みの場合はリダイレクト
    if (contractorAuthApi.isAuthenticated() && contractorAuthApi.isTokenValid()) {
      this.$router.push('/');
    }

    // フォーカスをメールアドレス入力欄に設定
    this.$nextTick(() => {
      const emailInput = document.getElementById('email');
      if (emailInput) {
        emailInput.focus();
      }
    });
  },

  methods: {
    /**
     * サインイン処理
     */
    async handleSignIn() {
      if (!this.isFormValid || this.isLoading) {
        return;
      }

      this.isLoading = true;
      this.clearMessages();

      try {
        const result = await contractorAuthApi.signIn(this.email.trim(), this.password);
        
        if (result.success) {
          this.successMessage = result.message;
          
          // 認証状態変化をアプリケーション全体に通知
          this.$root.$emit('contractor-auth-changed', { isAuthenticated: true });
          
          // 少し待ってからダッシュボードにリダイレクト
          setTimeout(() => {
            this.$router.push('/');
          }, 1000);
        } else {
          this.errorMessage = result.message;
        }
      } catch (error) {
        console.error('サインインエラー:', error);
        this.errorMessage = 'サインイン中にエラーが発生しました。再度お試しください。';
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * パスワード表示/非表示の切り替え
     */
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },

    /**
     * メールアドレスの検証
     */
    validateEmail() {
      this.emailError = '';
      
      if (!this.email.trim()) {
        return;
      }

      if (!this.isValidEmail(this.email)) {
        this.emailError = '有効なメールアドレスを入力してください';
      }
    },

    /**
     * パスワードの検証
     */
    validatePassword() {
      this.passwordError = '';
      
      if (!this.password.trim()) {
        return;
      }

      if (this.password.length < 6) {
        this.passwordError = 'パスワードは6文字以上で入力してください';
      }
    },

    /**
     * メールアドレスの形式チェック
     */
    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },

    /**
     * エラー・成功メッセージをクリア
     */
    clearMessages() {
      this.errorMessage = '';
      this.successMessage = '';
    }
  }
};